import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  addCustomerApi,
  addNoteApi,
  deleteCustomerApi,
  editCustomerApi,
  getCustomerByCodeApi,
  getCustomerByIdApi,
  getCustomerBySiteApi,
  getCustomersApi,
  getCustomersByBuildingApi,
  getCustomersByEntraceApi,
  getNotesApi,
} from '../api/customers.service';
import history from '../routes/history';
import {errorHandler} from '../utils/errorHandler';

function* getCustomersSaga(fn) {
  try {
    const response = yield call(getCustomersApi, fn.filters);
    yield put({
      type: AC.GET_CUSTOMERS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_BUILDINGS_FAILED);
  }
}

function* getCustomerBySiteSaga(fn) {
  try {
    const response = yield call(getCustomerBySiteApi, fn.siteCode, fn.siteNo); 
    yield put({
      type: AC.GET_CUSTOMERS_BY_SITE_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_CUSTOMERS_BY_SITE_FAILED); 
  }
}

function* getCustomerByCodeSaga(fn) {
  try {
    const response = yield call(getCustomerByCodeApi, fn.code); 
    yield put({
      type: AC.GET_CUSTOMERS_BY_CODE_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_CUSTOMERS_BY_CODE_FAILED); 
  }
}

function* getBuildingCustomersSaga(fn) {
  try {
    const response = yield call(
      getCustomersByBuildingApi,
      fn.buildingId,
      fn.filters,
    );
    yield put({
      type: AC.GET_BUILDING_CUSTOMERS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_BUILDING_CUSTOMERS_FAILED);
  }
}

function* getEntranceCustomersSaga(fn) {
  try {
    const response = yield call(
      getCustomersByEntraceApi,
      fn.entranceId,
      fn.filters,
    );
    yield put({
      type: AC.GET_ENTRANCE_CUSTOMERS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_ENTRANCE_CUSTOMERS_FAILED);
  }
}

function* getCustomerDetailsSaga(fn) {
  try {
    const response = yield call(getCustomerByIdApi, fn.id);
    yield put({type: AC.GET_CUSTOMER_DETAILS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_CUSTOMER_DETAILS_FAILED);
  }
}

function* addCustomerSaga(fn) {
  try {
    const response = yield call(addCustomerApi, fn.payload);
    yield put({
      type: AC.ADD_CUSTOMER_SUCCEED,
      payload: response.data,
      filters: {},
    });
    yield put(successToast('Customer created successfully!'));
    history.back();
  } catch (e) {
    yield errorHandler(e, AC.ADD_CUSTOMER_FAILED);
  }
}

function* editCustomerSaga(fn) {
  try {
    const response = yield call(editCustomerApi, fn.payload);
    yield put({
      type: AC.EDIT_CUSTOMER_SUCCEED,
      payload: response.data,
      id: fn.payload.id,
      filters: {},
    });
    yield put(successToast('Customer edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_CUSTOMER_FAILED);
  }
}

function* deleteCustomerSaga(fn) {
  try {
    const response = yield call(deleteCustomerApi, fn.id);
    yield put({
      type: AC.DELETE_CUSTOMER_SUCCEED,
      payload: response.data,
      filters: {},
    });
    yield put(successToast('Customer deleted successfully!'));
    history.back();
  } catch (e) {
    yield errorHandler(e, AC.DELETE_CUSTOMER_FAILED);
  }
}

function* addNoteSaga(fn) {
  try {
    yield call(addNoteApi, fn.payload);
    yield put({
      type: AC.ADD_NOTE_SUCCEED,
      customerId: fn.payload.customerId,
    });
    yield put(successToast('Note created successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.ADD_NOTE_FAILED);
  }
}

function* getNotesSaga(fn) {
  try {
    const response = yield call(getNotesApi, fn.customerId);
    yield put({
      type: AC.GET_NOTES_SUCCEED,
      payload: response.data,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_NOTES_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(AC.GET_CUSTOMERS_REQUEST, getCustomersSaga);
  yield takeLatest(AC.GET_CUSTOMERS_BY_SITE_REQUEST, getCustomerBySiteSaga);
  yield takeLatest(AC.GET_CUSTOMERS_BY_CODE_REQUEST, getCustomerByCodeSaga);
  yield takeLatest(AC.GET_BUILDING_CUSTOMERS_REQUEST, getBuildingCustomersSaga);
  yield takeLatest(AC.GET_ENTRANCE_CUSTOMERS_REQUEST, getEntranceCustomersSaga);
  yield takeLatest(
    [
      AC.GET_CUSTOMER_DETAILS_REQUEST,
      AC.EDIT_CUSTOMER_SUCCEED,
      AC.REACTIVATE_CARD_SUCCEED,
    ],
    getCustomerDetailsSaga,
  );
  yield takeLatest(AC.ADD_CUSTOMER_REQUEST, addCustomerSaga);
  yield takeLatest(AC.EDIT_CUSTOMER_REQUEST, editCustomerSaga);
  yield takeLatest(AC.DELETE_CUSTOMER_REQUEST, deleteCustomerSaga);
  yield takeLatest(AC.ADD_NOTE_REQUEST, addNoteSaga);
  yield takeLatest([AC.GET_NOTES_REQUEST, AC.ADD_NOTE_SUCCEED], getNotesSaga);
}

export default function* customersSaga() {
  yield all([actionWatcher()]);
}
